module.exports = __webpack_public_path__ + "img/kura-sushi-app.420f948f.jpg";